import { signInFirst } from '@/auth'

// The token rides to the auth server as `invite`, so a person with no account registers through it (invite-only-registration PRD).
export const invitationGuard = signInFirst(to => ({ invite: to.params.token }))
